// extracted by mini-css-extract-plugin
export var popper = "_a2-0";